function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#545DFF",
  d: "M25.333 0H4C1.797 0 0 1.797 0 4v16c0 2.203 1.797 4 4 4h21.333c2.203 0 4-1.797 4-4V4c0-2.203-1.797-4-4-4z",
  transform: "translate(-557.000000, -409.000000) translate(509.000000, 215.710281) translate(48.000000, 194.000000) translate(0.285746, 2.804296) translate(1.047473, 1.195704)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B8BBF2",
  d: "M4 2.667h21.333c.73 0 1.334.603 1.334 1.333v16c0 .73-.603 1.333-1.334 1.333H4c-.73 0-1.333-.603-1.333-1.333V4c0-.73.603-1.333 1.333-1.333z",
  transform: "translate(-557.000000, -409.000000) translate(509.000000, 215.710281) translate(48.000000, 194.000000) translate(0.285746, 2.804296) translate(1.047473, 1.195704)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#545DFF",
  d: "M27.235 2.908c.604-.423 1.435-.276 1.857.327.39.557.295 1.308-.196 1.753l-.131.104-13.334 9.334c-.408.285-.936.317-1.37.095l-.159-.095L.57 5.092C-.034 4.67-.181 3.84.24 3.235c.39-.556 1.128-.724 1.714-.415l.143.088 12.569 8.797 12.568-8.797z",
  transform: "translate(-557.000000, -409.000000) translate(509.000000, 215.710281) translate(48.000000, 194.000000) translate(0.285746, 2.804296) translate(1.047473, 1.195704)"
})))))));

var SvgIconsSms = function SvgIconsSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconsSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons-sms.f350eb71.svg";
export { ForwardRef as ReactComponent };